import styled from "styled-components";

export const HeaderWidgetContainer = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    gap: 16px;
    min-width: 500px;
    width: ${props => props.$fullWidth ? '100%' : 'fit-content'};
`